import Head from 'next/head';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

import Section from 'components/ToolSignin/Section';

import { ONBOARDING_FLOW_STATE } from 'lib/consts/flowState';
import { PAGE_ROUTES } from 'lib/page-routes';
import { useAuth } from 'lib/providers/AuthProvider';
import { fetchTranslationFiles, LOCALE_PAGES } from 'lib/services/page';

const SignIn: React.FC = () => {
  const router = useRouter();
  const { recruiter, isRecruiter, isInitialAuthLoading } = useAuth();
  const flow_state = recruiter?.flow_state;

  useEffect(() => {
    if (isRecruiter) {
      if (flow_state === ONBOARDING_FLOW_STATE.COMPLETE)
        router.push(PAGE_ROUTES.RECRUITER_DASHBOARD);
      else if (
        flow_state === ONBOARDING_FLOW_STATE.PRE_COMPLETE ||
        flow_state?.match(/post_/)
      )
        router.push(PAGE_ROUTES.RECRUITER_ONBOARDING);
      else router.push(PAGE_ROUTES.RECRUITER_SIGN_UP);
    }
  }, [flow_state, router, isRecruiter]);

  if (isInitialAuthLoading || isRecruiter) return null;

  return (
    <>
      <Head>
        <title>Recruiter Login | Huzzle</title>
        <meta name="description" content="Sign in to Huzzle as a Recruiter." />
      </Head>
      <Section isRecruiter />
    </>
  );
};

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await fetchTranslationFiles({
        locale,
        pages: [LOCALE_PAGES.SIGN_IN],
      })),
    },
  };
}

export default SignIn;
